<template>
  <v-dialog v-model="showDialog" persistent max-width="1200px">
    <v-card>
      <!-- <v-card-title  color="primary darken-4">
                                <span class="headline">AGREGAR SUCURSAL</span>
      </v-card-title>-->
      <v-toolbar color="primary darken-4" dark>
        <img
          :src="$store.state.iconoForm"
          height="42"
          alt="Acciones tipo producto"
        />
        <v-toolbar-title class="ml-0 pl-3">
          <span class="hidden-sm-and-down">{{ $store.state.tituloForm }}</span>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click.native="showDialog = false">
          <v-icon danger>close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-divider></v-divider>
      <v-card-text>
        <v-container grid-list-md>
          <v-form ref="formCorteCaja" :v-model="true" lazy-validation>
            <v-layout row wrap>
              <v-flex xs6 sm16 md6 lg6>
                <v-text-field
                  label="Fecha de corte"
                  v-model="corteCaja.fechaCorte"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex xs6 sm6 md6 lg6>
                <v-text-field
                  label="Monto límite de corte"
                  prefix="$"
                  v-model="corteCaja.montoCorteLimite"
                  placeholder="Cada que se supere esta cifra, se solicitará realizar corte de caja"
                  hint="Cada que se supere esta cifra, se solicitará realizar corte de caja"
                  readonly
                ></v-text-field>
              </v-flex>
            </v-layout>

            <v-flex xs12 sm12 md6>
              <v-text-field
                type="number"
                prefix="$"
                label="Monto recaudado desde el último corte"
                v-model="corteCaja.montoEnCuenta"
                hint="Monto que se ha recaudado en efectivo y pago con tarjeta"
                readonly
              ></v-text-field>
            </v-flex>

            <v-flex xs12 sm12 md6>
              <v-text-field
                type="number"
                prefix="$"
                label="Monto por el que realizarás el corte"
                placeholder="Especifica el monto por el que harás el corte"
                v-model="corteCaja.montoCorteARealizar"
                hint="Este monto se abonará al corte"
                :rules="[
                  () =>
                    corteCaja.montoCorteARealizar > 0 ||
                    'El valor debe ser mayor a $ 0',
                  !!corteCaja.montoCorteARealizar || 'El campo es requerido',
                ]"
              ></v-text-field>
            </v-flex>
          </v-form>
        </v-container>
        <br />
        <small>* Indica que el campo es requerido</small>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn depressed @click.native="showDialog = false">Cerrar</v-btn>
        <v-btn
          color="primary darken-4"
          :loading="$store.state.operationInProgress"
          @click="realizarCorte"
          >Guardar</v-btn
        >
      </v-card-actions>
      <v-alert
        :value="$store.state.operationSuccess"
        color="success"
        icon="check_circle"
        transition="scale-transition"
        >Corte realizado con éxito</v-alert
      >
      <v-alert
        :value="$store.state.operationFailed"
        color="error"
        icon="warning"
        transition="scale-transition"
      >
        <span v-html="$store.state.errorMessage"></span>
      </v-alert>
    </v-card>
  </v-dialog>
</template>

<script>
import corteCajaService from "@/services/corteCajaService";

export default {
  data() {
    return {
      showDialog: false,
      corteCaja: {
        sucursalId: null,
        nombreSucursal: "",
        fechaCorte: "",
        montoCorteLimite: 0,
        montoEnCuenta: 0,
        montoCorteRealizado: 0,
        montoCorteARealizar: 0,
      },
    };
  },
  mounted() {
    //this.getCorteCaja();
  },
  methods: {
    openDialog() {
      this.showDialog = true;
    },
    getCorteCaja() {
      let self = this;
      let current_user = this.$store.state.currentUser;
      let sucursalesUsuario = current_user.sucursales;

      corteCajaService
        .verificarCaja(sucursalesUsuario[0].sucursalId)
        .then((result) => {
          self.corteCaja = result;
        })
        .catch((e) => {
          console.log(e);
          self.operationFailed(e);
        });
    },
    realizarCorte() {
      let self = this;

      if (self.$refs.formCorteCaja.validate()) {
        self.operationStart();

        corteCajaService
          .realizarCorteCaja(self.corteCaja)
          .then((result) => {
            self.operationSuccess();
            self.descargarCorteCaja()
            setTimeout(() => {
              self.showDialog = false;
              self.resetForm();
              self.verificarCorteCaja();
            
            }, 2000);
          })
          .catch((e) => {
            console.log(e);
            self.operationFailed(e);
          });
      }
    },
    descargarCorteCaja() {

      var h = 900;
      var w = 400;
      var left = screen.width / 2 - w / 2;
      var top = screen.height / 2 - h / 2;
      var titulo = "VISUALIZACIÓN DEL DOCUMENTO";

      let self = this;
      self.showCargando = true;
      self.$store.state.loadingInfo.show = true;
      self.$store.state.loadingInfo.text = "Se está generando el ticket";

      corteCajaService
        .getCorteCajaTicket()
        .then((result) => {

          var byteCharacters = atob(result);
          var byteNumbers = new Array(byteCharacters.length);
          for (var i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }
          var byteArray = new Uint8Array(byteNumbers);
          var file = new Blob([byteArray], { type: "application/pdf;base64" });
          var fileURL = URL.createObjectURL(file);
          //window.open(fileURL);
          var newwindow = window.open(
            fileURL,
            titulo,
            "height=" + h + ",width=" + w + ", top=" + 5 + ", left=" + left
          );

          if (window.focus) {
            newwindow.focus();
            newwindow.print();
          }
          self.$store.state.loadingInfo.text = "Cargando información";
          self.$store.state.loadingInfo.show = false;
        })
        .catch((e) => {
          console.log(e);
          self.operationFailed(e);
        })
        .finally(() => {
          self.showCargando = false;
        });
    },
    resetForm() {
      let self = this;
      self.operationReset();
      self.corteCaja.sucursalId = null;
      self.corteCaja.nombreSucursal = "";
      self.corteCaja.fechaCorte = "";
      self.corteCaja.montoCorteLimite = 0;
      self.corteCaja.montoEnCuenta = 0;
      self.corteCaja.montoCorteRealizado = 0;
      self.corteCaja.montoCorteARealizar = 0;
      //self.$refs.formCorteCaja.resetValidation();
    },
  },
};
</script>
